import { service } from "@ember/service";
import Controller from "@ember/controller";
import { action } from "@ember/object";
import { task } from "ember-concurrency";

export default class DashboardInviteController extends Controller {
  @service session;
  @service router;

  get invite() {
    return this.model.invite;
  }

  get user() {
    return this.session.currentUser;
  }

  acceptTask = task(async () => {
    let organizationId = this.invite.organizationId;
    await this.invite.accept();
    this.router.transitionTo("organization.overview", organizationId);
  });

  @action
  switchUser() {
    let id = this.invite.id;
    this.send("logout", "logout", "dashboard.invite", id);
  }
}
